import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/guide/page.tsx");
